(function() {
  'use strict';

  const togglePopup = (popup, open) => {
    if (!popup) return;
    popup.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.klarna-popup-trigger');
    if (trigger) {
      e.preventDefault();
      togglePopup(document.getElementById('klarna-popup-' + trigger.getAttribute('data-popup-id')), true);
      return;
    }
    if (e.target.closest('.klarna-popup-close') || e.target.classList.contains('klarna-popup__backdrop')) {
      e.preventDefault();
      togglePopup(e.target.closest('.klarna-popup'), false);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') togglePopup(document.querySelector('.klarna-popup[aria-hidden="false"]'), false);
  });

  const formatMoney = (cents) => {
    const el = document.querySelector('.wt-cart__subtotal__value');
    if (!el) return (cents / 100).toFixed(2);
    const currency = el.textContent.match(/[^\d,.\s]+/)?.[0] || '';
    const value = (cents / 100).toFixed(el.textContent.includes('.') ? 2 : 0);
    return currency ? `${currency}${value}` : value;
  };

  const updatePopupPrices = (cartTotalPrice) => {
    document.querySelectorAll('.klarna-popup[data-cart-popup="true"]').forEach((popup) => {
      const priceElements = popup.querySelectorAll('[data-price-amount]');
      if (!priceElements.length) return;

      const amounts = {
        total: formatMoney(cartTotalPrice),
        klarna: formatMoney(Math.round(cartTotalPrice / 3)),
        paypal: formatMoney(Math.round(cartTotalPrice / 4))
      };

      priceElements.forEach((el) => {
        if (el.classList.contains('klarna-popup__option-total') || el.classList.contains('klarna-popup__price')) {
          el.textContent = (el.textContent.match(/^[^:]+:/)?.[0] + ' ' || '') + amounts.total;
          el.setAttribute('data-price-amount', cartTotalPrice);
        }
      });

      ['klarna', 'paypal'].forEach((type) => {
        const el = popup.querySelector(`[data-${type}-label]`);
        const template = el?.getAttribute(`data-${type}-label`);
        if (template) el.textContent = template.replace('{amount}', amounts[type]);
      });
    });
  };

  const setupCartUpdateListener = () => {
    if (typeof subscribe !== 'function') {
      setTimeout(setupCartUpdateListener, 100);
      return;
    }
    subscribe(PUB_SUB_EVENTS?.cartUpdate || 'cart-update', async (data) => {
      setTimeout(async () => {
        const cartTotalPrice = data?.cartData?.total_price || data?.total_price ||
          await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
            .then(r => r.ok ? r.json().then(c => c.total_price) : null)
            .catch(() => null);
        if (cartTotalPrice) updatePopupPrices(cartTotalPrice);
      }, 100);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartUpdateListener);
  } else {
    setupCartUpdateListener();
  }
})();
